import { UserOutlined } from '@ant-design/icons';
import { Layout, Menu, Typography, notification } from 'antd';
import ServicesContainer from '../services/Services';
import React, { useContext, useEffect } from 'react';
import firebase from 'firebase';
import { IContext, MainContext } from '../../contexts/mainContext';
import DriversContainer from '../drivers/Drivers';
import ClientsContainer from '../clients/clients';
import { Link, useParams } from 'react-router-dom';
import Vehicles from '../vehicles/Vehicles';
import Profile from '../profile/Profile';
import Budgets from '../budgets/Budgets';
import { getClient } from '../../apollo';
import {
  GetBudgetsDocument,
  GetBudgetsQuery,
  useGetAllClientsQuery,
  useGetBudgetsQuery,
  useOnNewBudgetSubscriptionCustomSubscription,
  useOnUpdateBudgetSubscriptionCustomSubscription,
  useOnNewServiceSubscriptionSubscription,
  useOnUpdateClientSubscription,
  useOnNewDriverSubscription,
  useOnUpdateServiceSubscriptionSubscription,
  useOnUpdateMeSubscription,
  useGetAllVehiclesQuery,
  OnNewClientDocument,
  OnNewClientSubscription,
  GetClientBasicInfoDocument,
  GetBudgetDocument,
  GetServiceDetailsDocument,
} from '../../graphql/datamodel.gen';
import { FETCH_ALL_SERVICES } from '../services/queries';
import _ from 'lodash';
import { ServicesContext } from '../../contexts/servicesContext';
import moment from 'moment';
import { FETCH_ALL_DRIVERS_LIST } from '../drivers/queries';
import ClientEmployees from '../clientEmployees/clientEmployees';
import Rate from '../rate/rate';
import { DrivingCompanies } from '../drivingCompanies';
import { ServiceOffers } from '../serviceOffers';
import { OfferedServices } from '../offeredServices';

interface IDashboard {
  preselectedMenu?:
    | 'services'
    | 'clients'
    | 'drivers'
    | 'vehicles'
    | 'profile'
    | 'budgets'
    | 'client_employees'
    | 'rates'
    | 'driving_companies'
    | 'service_offers'
    | 'offers';
}

const { Title } = Typography;

interface IDashboardViewProps {
  signout: () => Promise<any>;
  preselectedMenu: string;
  urlParams: any;
}

const openNotification = (message: string, description: string) => {
  notification.open({
    message,
    description,
  });
};

const DashboardView: React.FC<IDashboardViewProps> = (
  props: IDashboardViewProps,
) => {
  const {
    isAdmin,
    isClient,
    clientRole,
    name,
    isDriver,
    isPartOfDrivingCompany,
  } = useContext<IContext>(MainContext);
  const page = props.preselectedMenu || 'services';
  let title: string;

  if (page === 'services') {
    title = 'Gestión de servicios';
  }
  if (page === 'drivers') {
    title = 'Gestión de conductores';
  }
  if (page === 'clients') {
    title = 'Gestión de clientes';
  }
  if (page === 'vehicles') {
    title = 'Gestión de vehículos';
  }
  if (page === 'budgets') {
    title = 'Gestión de presupuestos';
  }
  if (page === 'profile') {
    title = 'Mi perfil';
  }
  if (page === 'client_employees') {
    title = 'Empleados';
  }
  if (page === 'rates') {
    title = 'Tarifarios';
  }
  if (page === 'driving_companies') {
    title = 'Empresas colaboradoras';
  }
  if (page === 'service_offers') {
    title = 'Ofertas de servicios';
  }
  if (page === 'offers') {
    title = 'Servicios en oferta';
  }

  const accountMenu = <b>{`Bienvenido, ${name}`}</b>;

  const MenuItems =
    !isAdmin && isClient && clientRole === 'ADMIN'
      ? [
          <Menu.Item key="services">
            <Link to={'/services'}>Servicios</Link>
          </Menu.Item>,
          <Menu.Item key={'budgets'}>
            <Link to={'/budgets'}>Presupuestos</Link>
          </Menu.Item>,
          <Menu.Item key={'client_employees'}>
            <Link to={'/employees'}>Empleados</Link>
          </Menu.Item>,
        ]
      : !isAdmin && isClient && clientRole === 'EMPLOYEE'
      ? [
          <Menu.Item key="services">
            <Link to={'/services'}>Servicios</Link>
          </Menu.Item>,
          // <Menu.Item key={'budgets'}>
          //   <Link to={'/budgets'}>Presupuestos</Link>
          // </Menu.Item>,
        ]
      : !isAdmin && isDriver && isPartOfDrivingCompany
      ? [
          <Menu.Item key="offers">
            <Link to={'/offers'}>Servicios en oferta</Link>
          </Menu.Item>,
        ]
      : isAdmin && !isClient
      ? [
          <Menu.Item key="services">
            <Link to={'/services'}>Servicios</Link>
          </Menu.Item>,
          <Menu.Item key={'budgets'}>
            <Link to={'/budgets'}>Presupuestos</Link>
          </Menu.Item>,
          <Menu.Item key="clients">
            <Link to={'/clients'}>Clientes</Link>
          </Menu.Item>,
          <Menu.Item key="drivers">
            <Link to={'/drivers'}>Conductores</Link>
          </Menu.Item>,
          <Menu.Item key={'vehicles'}>
            <Link to={'/vehicles'}>Vehículos</Link>
          </Menu.Item>,
          <Menu.Item key={'rates'}>
            <Link to={'/rates'}>Tarifarios</Link>
          </Menu.Item>,
          <Menu.Item key={'driving_companies'}>
            <Link to={'/driving_companies'}>Empresas colaboradoras</Link>
          </Menu.Item>,
          <Menu.Item key={'service_offers'}>
            <Link to={'/service_offers'}>Ofertas de servicio</Link>
          </Menu.Item>,
        ]
      : [];

  return (
    <Layout className="layout">
      <Layout.Header style={{ width: '100%' }}>
        {/*<div className="logo"></div>*/}
        <Menu
          theme="dark"
          mode="horizontal"
          defaultSelectedKeys={[page]}
          style={{ lineHeight: '64px' }}
          // onClick={({ item, key, keyPath, domEvent }) => {
          //   return <Redirect to={`/${key}`} />;
          //   //this.setState({ selectedMenu: key });
          // }}
        >
          {MenuItems}

          <Menu.SubMenu
            title={
              <span className="submenu-title-wrapper">
                <UserOutlined
                  style={{ marginRight: 8 }}
                  translate={undefined}
                />
                {accountMenu}
              </span>
            }
            style={{ marginLeft: 'auto' }}
          >
            <Menu.Item>
              <Link to={'/profile'}>Mi perfil</Link>
            </Menu.Item>
            <Menu.Item key="logout" onClick={props.signout}>
              Cerrar sesión
            </Menu.Item>
          </Menu.SubMenu>
        </Menu>
      </Layout.Header>
      <Title level={3} style={{ padding: '50px', paddingBottom: 0 }}>
        {title}
      </Title>
      <Layout.Content>
        <div style={{ background: '#fff', padding: 24, borderRadius: '4px' }}>
          {page === 'services' ? (
            <ServicesContainer
              isAdmin={isAdmin}
              isClient={isClient}
              filterServiceId={props.urlParams?.serviceId}
            />
          ) : page === 'drivers' ? (
            <DriversContainer />
          ) : page === 'clients' ? (
            <ClientsContainer />
          ) : page === 'vehicles' ? (
            // @ts-ignore
            <Vehicles {...props} />
          ) : page === 'profile' ? (
            <Profile />
          ) : page === 'budgets' ? (
            <Budgets />
          ) : page === 'client_employees' ? (
            <ClientEmployees />
          ) : page === 'rates' ? (
            <Rate />
          ) : page === 'driving_companies' ? (
            <DrivingCompanies />
          ) : page === 'offers' ? (
            <OfferedServices />
          ) : page === 'service_offers' ? (
            <ServiceOffers />
          ) : (
            <div>Sin autorización</div>
          )}
        </div>
        <Layout.Footer style={{ textAlign: 'center' }}>MVIPS</Layout.Footer>
      </Layout.Content>
    </Layout>
  );
};

const Dashboard: React.FC<IDashboard> = (props: IDashboard) => {
  const servicesContext = useContext(ServicesContext);
  const mainContext = useContext(MainContext);
  const urlParams = useParams();

  const signout = async () => {
    await getClient().clearStore();
    await firebase.auth().signOut();
  };

  useEffect(() => {
    if (!('Notification' in window)) {
      console.debug('This browser does not support desktop notification');
    } else {
      Notification.requestPermission();
    }
  });

  const getAllClientsQuery = useGetAllClientsQuery({
    client: getClient(),
    pollInterval: 900000,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'cache-and-network',
  });

  useEffect(() => {
    if (!mainContext.isDriver) {
      const unsubscribe =
        getAllClientsQuery.subscribeToMore<OnNewClientSubscription>({
          document: OnNewClientDocument,
          updateQuery: (prev, { subscriptionData }) => {
            if (!subscriptionData.data) return prev;

            const newClient = subscriptionData.data.onNewClient;

            return {
              clients: [newClient, ...prev.clients],
            };
          },
        });
      return () => {
        unsubscribe();
      };
    }
  }, [getAllClientsQuery, getAllClientsQuery.subscribeToMore]);

  useGetBudgetsQuery({
    client: getClient(),
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'cache-and-network',
    skip: mainContext.isDriver,
  });

  useGetAllVehiclesQuery({
    client: getClient(),
    skip: mainContext.isDriver,
    fetchPolicy: 'cache-and-network',
  });

  useOnUpdateMeSubscription({
    client: getClient(),
    shouldResubscribe: true,
    skip: mainContext.isDriver,
    onSubscriptionData: async ({ subscriptionData }) => {
      console.debug('Update me received via web sockets');
      const me = subscriptionData.data.onUpdateMe;

      if (me.disabled) {
        await getClient().clearStore();
        await firebase.auth().signOut();
        window.location.reload();
      }
    },
  });

  useOnUpdateServiceSubscriptionSubscription({
    client: getClient(),
    shouldResubscribe: false,
    skip: mainContext.isDriver,
    onSubscriptionData: ({ subscriptionData }) => {
      console.debug('Updated service recived via websockets', subscriptionData);
      const client = getClient();

      client.writeQuery({
        query: GetServiceDetailsDocument,
        data: subscriptionData.data.onUpdateService,
        id: subscriptionData.data.onUpdateService.id,
      });
    },
  });

  useOnNewServiceSubscriptionSubscription({
    client: getClient(),
    shouldResubscribe: false,
    skip: mainContext.isDriver,
    onSubscriptionData: ({ subscriptionData }) => {
      console.debug('New service received via websockets', subscriptionData);
      const client = getClient();

      try {
        const departureDateMin = moment(servicesContext.departureDateMin);
        const departureDateMax = moment(servicesContext.departureDateMax);

        const serviceDepartureDate = moment(
          subscriptionData.data.onNewService.departure.date,
        );

        if (
          serviceDepartureDate.unix() >= departureDateMin.unix() &&
          serviceDepartureDate.unix() <= departureDateMax.unix()
        ) {
          const previous = client.readQuery({
            query: FETCH_ALL_SERVICES,
            variables: {
              departureDateMin: servicesContext.departureDateMin,
              departureDateMax: servicesContext.departureDateMax,
            },
          });

          const previousClone = _.cloneDeep(previous);

          const data = {
            services: [
              ...previousClone.services,
              subscriptionData.data.onNewService,
            ],
          };

          client.writeQuery({
            query: FETCH_ALL_SERVICES,
            data,
          });
          // @ts-ignore
          client.queryManager.broadcastQueries();

          if (
            !previousClone.services.find(
              (service) =>
                service.id ===
                subscriptionData.data.onNewService.volcanoServiceId,
            )
          ) {
            openNotification(
              'Nuevo servicio',
              'Un nuevo servicio ha sido creado',
            );
            new Notification('MVIPS', {
              body: 'Un nuevo servicio ha sido creado',
            });
          }
        }
      } catch (e) {}
    },
  });

  useOnUpdateClientSubscription({
    client: getClient(),
    shouldResubscribe: false,
    skip: mainContext.isDriver,
    onSubscriptionData: ({ subscriptionData }) => {
      const client = getClient();

      client.writeQuery({
        query: GetClientBasicInfoDocument,
        data: subscriptionData.data.onUpdateClient,
        id: subscriptionData.data.onUpdateClient.id,
      });
    },
  });

  useOnNewDriverSubscription({
    client: getClient(),
    shouldResubscribe: false,
    skip: mainContext.isDriver,
    onSubscriptionData: ({ subscriptionData }) => {
      console.debug('New driver received via websockets', subscriptionData);

      const client = getClient();

      const previousDrivers = client.readQuery({
        query: FETCH_ALL_DRIVERS_LIST,
      });

      const previousDriversClone = _.cloneDeep(previousDrivers);

      const data = {
        drivers: [
          ...previousDriversClone.drivers,
          subscriptionData.data.onNewDriver,
        ],
      };

      client.writeQuery({
        query: FETCH_ALL_DRIVERS_LIST,
        data,
      });
      // @ts-ignore
      client.queryManager.broadcastQueries();
    },
  });

  useOnUpdateBudgetSubscriptionCustomSubscription({
    client: getClient(),
    shouldResubscribe: false,
    skip: mainContext.isDriver,
    onSubscriptionData: ({ subscriptionData }) => {
      const client = getClient();
      client.writeQuery({
        query: GetBudgetDocument,
        data: subscriptionData.data.onUpdateBudget,
        id: subscriptionData.data.onUpdateBudget.id,
      });
    },
  });

  useOnNewBudgetSubscriptionCustomSubscription({
    client: getClient(),
    shouldResubscribe: false,
    skip: mainContext.isDriver,
    onSubscriptionData: ({ subscriptionData }) => {
      console.debug('New budget received via websockets', subscriptionData);
      const client = getClient();

      try {
        const previous = client.readQuery<GetBudgetsQuery>({
          query: GetBudgetsDocument,
        });

        const previousClone = _.cloneDeep(previous);

        const data = {
          budgets: [...previousClone.budgets, subscriptionData.data.newBudget],
        };
        client.writeQuery({
          query: GetBudgetsDocument,
          data,
        });
        // @ts-ignore
        client.queryManager.broadcastQueries();
        openNotification(
          'Nuevo presupuesto',
          'Un nuevo presupuesto ha sido creado en el sistema',
        );
      } catch (e) {}
    },
  });

  return (
    <DashboardView
      signout={signout}
      preselectedMenu={props.preselectedMenu}
      urlParams={urlParams}
    />
  );
};

export default Dashboard;
